export { default } from './Payment.container';


// WEBPACK FOOTER //
// ./src/components/Payment/index.ts